<section id="hero" class="scroll-mt-24">
  <app-hero-section></app-hero-section>
</section>

<section id="highlight" class="scroll-mt-24">
  <app-highlight-section></app-highlight-section>
</section>

<section id="stats" class="scroll-mt-24">
<app-stats-section></app-stats-section>
</section>

<section id="about" class="scroll-mt-24">
  <app-about-section></app-about-section>
</section>


<section id="service" class="scroll-mt-24">
  <app-service-section></app-service-section>
</section>

<section id="join" class="scroll-mt-24">>
  <app-final-join-section></app-final-join-section>
</section>


<section id="join" class="scroll-mt-24">>
  <app-investment-prog></app-investment-prog>
</section>


<section id="cta" class="scroll-mt-24">
  <app-brand-cta-section></app-brand-cta-section>
</section>


<section id="final-stats">
  <app-final-stats-section></app-final-stats-section>
</section>



